export default "__VITE_ASSET__C89bXJIB__"